import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { CreditCard } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function PilatesYogaSubscriptionsPage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Mensalidades"
      description="Gerencie as mensalidades dos seus alunos."
      icon={CreditCard}
    />
  
    </MainLayout>);
}

